/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import commonJobsStyles from "./commonJobsStyles";

const wayWeWorkSectionStyle = {
  ...commonJobsStyles,
  item: {
    padding: "1rem",
    margin: "1rem",
    textAlign: "center",
    border: "1px solid ",
    borderColor: "primary.main",
  },
  officeImg: {
    display: "block",
    margin: "auto",
    maxWidth: "100%",
  },
};

export default wayWeWorkSectionStyle;
